import gql from 'graphql-tag';

import { inlineCommentFragment } from './InlineCommentFragment.fragment';

export const ResolvedInlineCommentsQuery = gql`
	query ResolvedInlineCommentsQuery($pageId: ID!) {
		comments(pageId: $pageId, type: RESOLVED, depth: ROOT) {
			nodes {
				...inlineCommentFragment
				location {
					... on InlineComment {
						type
						inlineMarkerRef
						inlineText
						inlineResolveProperties {
							resolvedByDangling
							resolvedTime
							resolvedFriendlyDate
							resolvedUser
						}
					}
				}
				createdAt {
					value
				}
				replies {
					...inlineCommentFragment
					createdAt {
						value
					}
				}
			}
			totalCount
		}
	}
	${inlineCommentFragment}
`;
